import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'arrow'];

  connect() {
    this.openMenu = null;
  }

  toggleMenu(event) {
    const index = event.currentTarget.dataset.index || '0'
    const type = event.currentTarget.dataset.type || 'fade'
    const rotateClass = event.currentTarget.dataset.rotateClass || ''

    if (this.openMenu === index) {
      this.closeAllMenus(type, rotateClass);
      this.openMenu = null;
    } else {
      this.showMenu(index, type, rotateClass);
      this.openMenu = index;
    }
  }

  showMenu(index, type, rotateClass) {
    this.closeAllMenus(type, rotateClass);
    this.menuTargets.forEach((menu, i) => {
      if (i == index) {
        const classes = this.generateClasses(type)
        menu.classList.remove(...classes.hide);
        menu.classList.add(...classes.show);
      }
    });
    this.arrowTargets.forEach((arrow, i) => {
      if (i == index) {
        arrow.classList.add(rotateClass);
      }
    });
  }

  closeAllMenus(type, rotateClass) {
    this.menuTargets.forEach(menu => {
      const classes = this.generateClasses(type)
      menu.classList.remove(...classes.show);
      menu.classList.add(...classes.hide);
    });
    this.arrowTargets.forEach(arrow => {
      arrow.classList.remove(rotateClass);
    });
  }

  generateClasses(type) {
    switch (type) {
      case 'fade':
        return {
          show: ['opacity-100', 'visible'],
          hide: ['opacity-0', 'invisible']
        }
      case 'slide':
        return {
          show: ['h-full', 'opacity-100'],
          hide: ['h-0', 'opacity-0']
        }
    }
  }
}
